/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'

export const _4 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>4 - Стадия размонтирования</h2>
    <p className={styles.description}>
      В какой-то момент компоненты будут удалены из DOM. При этом вызывается следующий метод.{' '}
    </p>
    <CopyBlock text={`componentWillUnmount() {}`} language="javascript" showLineNumbers={false} theme={ocean} />
    <ul className={styles.list}>
      <li className={styles.list__item}>Вызывается перед размонтированием и удалением элемента из DOM</li>
      <li className={styles.list__item}>
        Отлично подходим для уборки за собой: слушатели, таймеры, HTTP-запросы. В противном случае будут утечки памяти
      </li>
      <li className={styles.list__item}>
        Вызывать <code className={styles.code}>setState()</code> нет смысла, компонент никогда не перерендерится
      </li>
    </ul>
  </section>
))
